import React, { useState } from 'react';
import { motion } from 'framer-motion';
import '../css/certificate_section.css';

export default function CertificateSection() {
    const [showMore, setShowMore] = useState(false);

    const toggleCertificates = () => {
        setShowMore(prev => !prev);
    };

    // Smooth Animation variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
                delayChildren: 0.15,
                ease: [0.25, 0.46, 0.45, 0.94]
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 35, scale: 0.96 },
        visible: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: {
                duration: 0.6,
                ease: [0.25, 0.46, 0.45, 0.94]
            }
        }
    };

    const titleVariants = {
        hidden: { opacity: 0, y: -30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.7,
                ease: [0.25, 0.46, 0.45, 0.94]
            }
        }
    };

    return (
        <>
            {/* Certificate Section */}
            <section className="certificate-section">
                <motion.h2
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={titleVariants}
                >
                    Education & Certifications
                </motion.h2>
                <motion.p
                    className="edu-cert-tagline"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2, duration: 0.5 }}
                >
                    Knowledge backed by credentials.
                </motion.p>

                <div className="edu-cert-wrapper">

                    {/* Education Block */}
                    <motion.div
                        className="education-block"
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
                        whileHover={{ scale: 1.02 }}
                    >
                        <div className="edu-icon">
                            <img src="images/grad-logo.png" alt="Education Icon" />
                        </div>
                        <div className="edu-details">
                            <h3>FAST University</h3>
                            <p className="degree">Bachelor of Science in Software Engineering</p>
                            <p className="grad-date">Expected Graduation: 2026</p>
                            <p className="coursework-label">Relevant Coursework:</p>
                            <p className="coursework">
                                Data Structures & Algorithms, Object-Oriented Programming,<br />
                                Database Systems, Web Development
                            </p>
                        </div>
                    </motion.div>

                    {/* Certification Cards */}
                    <motion.div
                        className="certificate-grid"
                        id="certificateGrid"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, margin: "-50px" }}
                        variants={containerVariants}
                    >
                        {/* Always Visible */}

                        <motion.a
                            href="certificates/Supervised Machine Learning.pdf"
                            target="_blank"
                            className="certificate-card"
                            rel="noreferrer"
                            variants={itemVariants}
                            whileHover={{ scale: 1.05, y: -8 }}
                            whileTap={{ scale: 0.98 }}
                        >
                            <img src="images/Supervised_Machine_Learning.png" alt="Supervised Machine Learning" />
                            <p>Supervised Machine Learning</p>
                        </motion.a>


                        <motion.a
                            href="certificates/IBM_Python for Data Science, AI & Development.pdf"
                            target="_blank"
                            className="certificate-card"
                            rel="noreferrer"
                            variants={itemVariants}
                            whileHover={{ scale: 1.05, y: -8 }}
                            whileTap={{ scale: 0.98 }}
                        >
                            <img src="images/Python for Data Science, AI & Development.png" alt="Python for Data Science, AI & Development" />
                            <p>Python for Data Science, AI & Development</p>
                        </motion.a>

                        <motion.a
                            href="certificates/Django Tutorial.pdf"
                            target="_blank"
                            className="certificate-card"
                            rel="noreferrer"
                            variants={itemVariants}
                            whileHover={{ scale: 1.05, y: -8 }}
                            whileTap={{ scale: 0.98 }}
                        >
                            <img src="images/Django_Certificate.png" alt="Django_Certificate" />
                            <p>Django</p>
                        </motion.a>


                        {/* Hidden Conditionally */}
                        {showMore && (
                            <>


                                <motion.a
                                    href="certificates/Agile Project Management.pdf"
                                    target="_blank"
                                    className="certificate-card"
                                    rel="noreferrer"
                                    initial={{ opacity: 0, scale: 0.9 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    transition={{ duration: 0.4 }}
                                    whileHover={{ scale: 1.05, y: -8 }}
                                    whileTap={{ scale: 0.98 }}
                                >
                                    <img src="images/Agile_Project_Management.jpeg" alt="Agile_Project_Management" />
                                    <p>Agile Project Management</p>
                                </motion.a>

                                <motion.a
                                    href="certificates/Introduction to Docker.pdf"
                                    target="_blank"
                                    className="certificate-card"
                                    rel="noreferrer"
                                    initial={{ opacity: 0, scale: 0.9 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    transition={{ duration: 0.4, delay: 0.1 }}
                                    whileHover={{ scale: 1.05, y: -8 }}
                                    whileTap={{ scale: 0.98 }}
                                >
                                    <img src="images/docker_certificate.png" alt="Docker" />
                                    <p>Docker</p>
                                </motion.a>
                                <motion.a
                                    href="certificates/React.pdf"
                                    target="_blank"
                                    className="certificate-card"
                                    rel="noreferrer"
                                    initial={{ opacity: 0, scale: 0.9 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    transition={{ duration: 0.4, delay: 0.2 }}
                                    whileHover={{ scale: 1.05, y: -8 }}
                                    whileTap={{ scale: 0.98 }}
                                >
                                    <img src="images/React_Certificate.png" alt="React" />
                                    <p>React</p>
                                </motion.a>

                                <motion.a
                                    href="certificates/Prompt Engineering.pdf"
                                    target="_blank"
                                    className="certificate-card"
                                    rel="noreferrer"
                                    initial={{ opacity: 0, scale: 0.9 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    transition={{ duration: 0.4, delay: 0.3 }}
                                    whileHover={{ scale: 1.05, y: -8 }}
                                    whileTap={{ scale: 0.98 }}
                                >
                                    <img src="images/Prompt Engineering.png" alt="Prompt Engineering" />
                                    <p>Prompt Engineering Essential</p>
                                </motion.a>

                                {/* Add more <a> blocks for additional certs here */}
                            </>
                        )}
                    </motion.div>

                    {/* Show More Button */}
                    <motion.div
                        style={{ textAlign: 'center', marginTop: '1.5rem' }}
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.5 }}
                    >
                        <motion.button
                            onClick={toggleCertificates}
                            id="showMoreBtn"
                            className="showmore-btn"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            {showMore ? 'Show Less' : 'Show More'}
                        </motion.button>
                    </motion.div>
                </div>
            </section>

            {/* Find me Somewhere else */}
            <section className="find-me">
                <motion.h2
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={titleVariants}
                >
                    Get In Touch
                </motion.h2>
                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2 }}
                >
                    Ready to take on your next big idea. Let's talk!
                </motion.p>
                <motion.div
                    className="social-links"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={containerVariants}
                >
                    <motion.a
                        href="https://www.linkedin.com/in/ashar-naveed-39499a25b/"
                        target="_blank"
                        className="social-card"
                        rel="noreferrer"
                        variants={itemVariants}
                        whileHover={{ scale: 1.08, y: -4 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <img src="images/linkedin.png" alt="LinkedIn" />
                        LinkedIn
                    </motion.a>
                    <motion.a
                        href="https://github.com/Ashar134"
                        target="_blank"
                        className="social-card"
                        rel="noreferrer"
                        variants={itemVariants}
                        whileHover={{ scale: 1.08, y: -4 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <img src="images/github.png" alt="GitHub" />
                        GitHub
                    </motion.a>
                    <motion.a
                        href="https://x.com/AsharNavee72062"
                        target="_blank"
                        className="social-card"
                        rel="noreferrer"
                        variants={itemVariants}
                        whileHover={{ scale: 1.08, y: -4 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <img src="images/twitter.png" alt="Twitter" />
                        Twitter
                    </motion.a>

                    <motion.a
                        href="https://www.figma.com/@asharnaveed"
                        target="_blank"
                        className="social-card"
                        rel="noreferrer"
                        variants={itemVariants}
                        whileHover={{ scale: 1.08, y: -4 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <img src="images/figma.png" alt="Figma" />
                        Figma
                    </motion.a>
                </motion.div>
                <motion.p
                    className="open-to-work"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.4 }}
                >
                    Open to freelance, full-time, and internship roles. Let's create something exceptional together.
                </motion.p>
            </section>
        </>
    );
}
